import { render, staticRenderFns } from "./MatricPicker.vue?vue&type=template&id=5e03c08a&scoped=true"
import script from "./MatricPicker.vue?vue&type=script&lang=ts"
export * from "./MatricPicker.vue?vue&type=script&lang=ts"
import style0 from "./MatricPicker.vue?vue&type=style&index=0&id=5e03c08a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e03c08a",
  null
  
)

export default component.exports